import { useTranslation } from 'react-i18next'

import { isValidEmail } from '#/shared/lib/format'
import { PhoneEditor } from '#/shared/ui/phone-editor'
import type { PhoneEditorProps } from '#/shared/ui/phone-editor'

type EmailEditorProps = Omit<PhoneEditorProps, 'enableSubject'>

function EmailEditor(props: EmailEditorProps) {
  const { t } = useTranslation()
  return (
    <PhoneEditor
      enableSubject
      enableTable
      enableImage
      enableLink
      enableTextAlign
      enableSource
      enableHtmlFidelity
      validateRecipient={isValidEmail}
      saveLabel={props.saveLabel ?? t('editor.email.save')}
      placeholder={props.placeholder ?? t('editor.email.placeholder')}
      {...props}
    />
  )
}

export { EmailEditor }
export type { EmailEditorProps }
